export default "__VITE_ASSET__ef897953__"